import { all } from "redux-saga/effects";
import webSaga from "./webSaga";
import partnerSaga from "./partnerSaga";
import staticpageSaga from "./staticpageSaga";

export default function* rootSaga() {
    yield all([
        webSaga(),
        partnerSaga(),
        staticpageSaga()
    ])
};